import React from "react";

export function getPrimaryHealthAlert(health) {
    if (!health?.alerts?.length) return null;
    const error = health.alerts.find((a) => a.level === "error");
    if (error) return error;
    const warning = health.alerts.find((a) => a.level === "warning");
    if (warning) return warning;
    return null;
}

export default function EmailHealthAlert({ health, compact = false, className = "" }) {
    if (!health || health.status === "ok") return null;

    const primary = getPrimaryHealthAlert(health);
    if (!primary) return null;

    const allMessages = health.alerts
        .filter((a) => a.level !== "ok")
        .map((a) => a.message)
        .join("\n");

    const isBlocked = health.status === "blocked";

    if (compact) {
        return (
            <span
                className={`email-health-alert email-health-alert--compact ${isBlocked ? "email-health-alert--blocked" : "email-health-alert--warning"} ${className}`.trim()}
                title={allMessages}
            >
                <i className="bi bi-exclamation-triangle-fill" aria-hidden="true"></i>
            </span>
        );
    }

    return (
        <div
            className={`email-health-alert ${isBlocked ? "email-health-alert--blocked" : "email-health-alert--warning"} ${className}`.trim()}
            title={allMessages}
            role="alert"
        >
            <i className="bi bi-exclamation-triangle-fill" aria-hidden="true"></i>
            <span>{primary.message}</span>
        </div>
    );
}
